import { render, staticRenderFns } from "./StoresTab.vue?vue&type=template&id=ad522ae8"
import script from "./StoresTab.vue?vue&type=script&lang=js"
export * from "./StoresTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports